import React, { useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import DashboardWrap from '../../components/DashboardWrap';
import RealtorReferralDetailsCard from './RealtorReferralDetailsCard';
import RealtorReferralTableRecord from './RealtorReferralTableRecord';
import GoBackIcon from '../../svgs/GoBackIcon';

import Styles from './RealtorDetails.module.scss';

const RealtorDetails = () => {
  const { push } = useHistory();
  const { agentId } = useParams<{ agentId: string }>();
  const [referralId, setReferralId] = useState(null);
  return (
    <DashboardWrap>
      <div className={Styles.wrapper}>
        <div className={Styles.wrapper__title}>
          <span>
            <GoBackIcon
              onClick={() => push('/rewards/realtors-tracking-code?page=1')}
            />
            Realtor's Tracking Code
          </span>
        </div>
        <RealtorReferralDetailsCard
          rewardId={agentId}
          setReferralId={(data) => setReferralId(data)}
        />
        <RealtorReferralTableRecord referralId={referralId} />
      </div>
    </DashboardWrap>
  );
};

export default RealtorDetails;
